import { useState } from 'react';

import { Share2 } from 'lucide-react';
import Image from 'next/image';

import SharePopup from './SharePopup';

import { h5BaseURL } from '@/utils/baseUrl';

export default function ProductHeader({ data }) {
  const [openShare, setOpenShare] = useState(false);

  const handleNavSearch = () => {
    window.location.href = `${h5BaseURL}/pages/search-list/search-list?keyword=${data?.productRecord?.productCode}&fromPage=pc_item`;
  };

  const handleNavCard = () => {
    window.location.href = `${h5BaseURL}/pages/cart-page/index?fromPage=pc_item`;
  };

  return (
    <>
      <header className="fixed top-0 px-[16px] w-[100%] h-[56px] flex items-center bg-[#FFFFFF] shadow-[rgba(236,236,236,0.5)_0px_-1px_inset] z-[10]">
        <Share2 width={20} height={20} onClick={() => setOpenShare(true)} />
        <div
          className="flex-1 mx-[16px] py-[2px] pr-[2px] pl-3 h-[36px] flex items-center justify-between border border-[#0A6FE9] rounded-full"
          onClick={handleNavSearch}
        >
          <Image
            className="mr-[4px]"
            src={'https://static.szlcsc.com/ecp/assets/app/op_5.1/search_icon.svg'}
            alt="搜索"
            width={14}
            height={14}
          ></Image>
          <div className="flex-1 text-[12px] text-[#999]">型号/品牌/参数/关键字</div>
          <button className="w-[50px] h-[32px] bg-[#0A6FE9] rounded-full text-white text-[14px]">搜索</button>
        </div>
        <Image
          src={'https://static.szlcsc.com/ecp/assets/app/product-list/cart.png'}
          alt="购物车"
          width={15}
          height={15}
          onClick={handleNavCard}
        ></Image>
      </header>
      <div className="h-[56px]"></div>
      <SharePopup open={openShare} onClose={() => setOpenShare(false)}></SharePopup>
    </>
  );
}
